import { useDispatch } from "react-redux";
import { Button, PanelSlider } from "../../../components/ui";
import cancelIcon from "../../../assets/images/close.svg";
import {
  resetApprRejectFields,
  setEditMarketDetailsStatus,
  setMarketImages,
  setOpenMarketDetailsPanel,
  udpateAddMarketData,
} from "../../../reducers/marketSlice";
import MarketMandiRmDetailsCard from "./market-details-card";
import CardHeaderBG from "../../../components/components-library/card-header-bg";
import TotalsCard from "../../../components/components-library/totals-card";
import { AccountBalanceOutlined } from "@mui/icons-material";
import MarketHoursList from "./market-hours-list";
import MarketMonthsData from "./market-months-data";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";
import useMarketDetailsById from "./useMarketDetailsbyId";
import DocumentPreview from "../../../components/commons/document-preview";
import MarketStatusDropdown from "./market-status-dropdown";
import MarketSelectorDropdown from "./market-selection-dropdown";
import Loading from "../../../assets/images/loading.gif";
import ModalHeader from "../../../components/ui/modal/modal-header";
import Modal from "../../../components/ui/modal";
import ModalFooter from "../../../components/ui/modal/modal-footer";
import DeleteMarket from "./delete-market";
import RejectMarket from "./reject-market";
import ApproveMarket from "./approve-market";
import reviewYellow from "../../../assets/images/reviewYellow.svg";
import reject from "../../../assets/images/reject.svg";
import DocumentViewer from "../../../components/commons/document-preview";
import { useUIPermissions } from "../../../layout/config/permissionUtils";

const MarketDetailsById: React.FC<{ onEditClick: any }> = ({ onEditClick }) => {
  const dispatch = useDispatch();
  const {
    marketDeatisById,
    showSeeAllCrops,
    setShowSeeAllCrops,
    onChangeMarketStatus,
    role,
    selectedMarketId,
    allMarketsData,
    selectedMarket,
    setSelectedMarket,
    isLoading,
    deletMarketModalStatus,
    setDeletMarketModalStatus,
    selectDeleteMarkets,
    setSelectDelMarkets,
    onClickDeleteMarket,
    onCloseDeleteModal,
    activeMarketTab,
    rejectMarketModalStatus,
    setRejectMarketModalStatus,
    approveMarketModalStatus,
    setApproveMarketModalStatus,
    handleApproveMarket,
    handleRejectMarket,
  } = useMarketDetailsById();
  const { hasAdminManagerEditAccess } = useUIPermissions();
  return (
    <>
      <div className="">
        <div className="border-b card_space_18 flex items-center justify-between">
          {marketDeatisById != null ? (
            <MarketSelectorDropdown
              markets={allMarketsData}
              selectedMarket={selectedMarket}
              onChange={(market) => setSelectedMarket(market)}
            />
          ) : (
            <span className="text-sm ">{selectedMarketId}</span>
          )}

          <img
            src={cancelIcon}
            alt="Close"
            className="cursor-pointer"
            onClick={() => {
              dispatch(setOpenMarketDetailsPanel(false));
            }}
          />
        </div>
        {marketDeatisById != null ? (
          <div
            className=" h-[100vh] bg-gray-bg overflow-y-auto"
            id="scroll_style"
            style={{ height: "calc(100vh - 8.5rem)" }}
          >
            <div className=" flex gap-2 card_space_18 sticky top-0 bg-white z-30">
              <div className="flex-1">
                <span className="fs-14 block mb-2 ml-1">Market:</span>
                <MarketMandiRmDetailsCard
                  name={marketDeatisById?.marketName}
                  subText={[
                    marketDeatisById?.address?.addressLine,
                    marketDeatisById?.address?.city,
                    marketDeatisById?.address?.state,
                    marketDeatisById?.address?.pincode
                      ? `- ${marketDeatisById?.address?.pincode}`
                      : "",
                  ]
                    .filter(Boolean)
                    .join(", ")}
                  profileImg={""}
                  fromMarketCard={true}
                  riskScore={marketDeatisById?.marketOrs}
                  id={marketDeatisById?.marketId}
                />
              </div>

              <div className="flex-1">
                <span className="fs-14 block mb-2 ml-1">Market Head:</span>
                {marketDeatisById?.employee?.name ? (
                  <MarketMandiRmDetailsCard
                    name={marketDeatisById?.employee?.name}
                    subText={marketDeatisById?.employee?.mobile}
                    profileImg={marketDeatisById?.employee?.profilePic}
                    fromMarketCard={false}
                    riskScore={marketDeatisById?.employee?.ors}
                    className="min-h-[114px]"
                    id={marketDeatisById?.employee?.onoId}
                  />
                ) : (
                  <div className="flex w-full border br-10 min-h-[114px] card_space_18 items-center">
                    <span className="text-sm"> No Rm Assigned</span>
                  </div>
                )}
              </div>

              <div className="flex-1">
                <span className="fs-14 block mb-2 ml-1">Market Status:</span>
                {activeMarketTab === "ALL" ? (
                  <div className="bg-white rounded-lg border flex items-center min-h-[114px] cursor-pointer">
                    <MarketStatusDropdown
                      marketStatus={
                        marketDeatisById?.status === 1 ? "ACTIVE" : "INACTIVE"
                      }
                      onChangeMarketStatus={onChangeMarketStatus}
                      roleType={role}
                      activeMarketTab={activeMarketTab}
                    />
                  </div>
                ) : activeMarketTab === "PENDING" ? (
                  <div className="bg-white rounded-lg border flex gap-2 items-center min-h-[114px] px-4">
                    <div>
                      <img src={reviewYellow} className="" />
                    </div>
                    <div className="color-yellow">Under Review</div>
                  </div>
                ) : activeMarketTab === "REJECTED" ? (
                  <div className="bg-white rounded-lg border flex gap-2 items-center min-h-[114px] px-4">
                    <div>
                      <img src={reject} className="w-6 h-6" />
                    </div>
                    <div className="color-red">Rejected</div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="outlet_padding flex gap-4">
              {" "}
              <div className="w-50">
                <CardHeaderBG
                  titile={"Market Details"}
                  titileClassName="bg-oceangreen"
                  icon=""
                  className=""
                >
                  <div className="card_space_18">
                    <div className="flex gap-4   relative">
                      <TotalsCard
                        totalVal={marketDeatisById?.marketName}
                        headerName="Market Name"
                        className="flex-1"
                      />
                      <TotalsCard
                        totalVal={marketDeatisById?.marketType}
                        headerName="Market Type"
                      />
                      <TotalsCard
                        totalVal={marketDeatisById?.licenceType}
                        headerName="Market License Type"
                      />
                    </div>
                    <div className="flex gap-4 space_18  relative">
                      <TotalsCard
                        totalVal={marketDeatisById?.address?.longitude}
                        headerName="Longitude"
                      />
                      <TotalsCard
                        totalVal={marketDeatisById?.address?.latitude}
                        headerName="Latitude"
                      />
                      <TotalsCard
                        totalVal={marketDeatisById?.marketSize}
                        headerName="Market Size"
                      />
                    </div>
                    <div className="flex gap-4 space_18  relative">
                      <TotalsCard
                        totalVal={marketDeatisById?.empCount}
                        headerName="Number of Employees"
                      />
                      <TotalsCard
                        totalVal={marketDeatisById?.headName}
                        headerName="Office Head"
                      />
                      <TotalsCard
                        totalVal={marketDeatisById?.shopCount}
                        headerName="Number of Mandi/Shops"
                      />
                    </div>
                    <div className="flex gap-4 space_18">
                      <div className={"flex-1"}>
                        <div className="fs-12 color-sub-text mb-1">
                          Market Pictures
                        </div>

                        {marketDeatisById?.marketImgs?.length > 0 ? (
                          <div className="flex gap-2 overflow-x-auto overflow-y-hidden">
                            {marketDeatisById?.marketImgs?.map((doc, i) => (
                              <div className="shrink-0 br-10 border doc_card relative">
                                <a href={doc.url} target="_blank">
                                  <DocumentViewer
                                    url={doc.url}
                                    docType={
                                      doc.url?.toLowerCase().endsWith(".pdf")
                                        ? "pdf"
                                        : doc.url
                                              ?.toLowerCase()
                                              .match(/\.(mp4|webm|mov)$/)
                                          ? "video"
                                          : "image"
                                    }
                                  />
                                </a>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div
                            className=" flex justify-center items-center bg-gray-light br-10 p-[10px] doc_card text-center cursor-pointer "
                            style={{
                              border: "1px dashed #595959",
                            }}
                          >
                            <span className="fs-12"> No Document Uploaded</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                    >
                      <span className="fs-14">Market Address</span>
                    </div>
                    <div className="card_space_18">
                      <div className="flex gap-4   relative">
                        <TotalsCard
                          totalVal={marketDeatisById?.address?.pincode}
                          headerName="Pincode"
                          className="flex-1"
                        />
                        <TotalsCard
                          totalVal={marketDeatisById?.address?.state}
                          headerName="State"
                        />
                        <TotalsCard
                          totalVal={marketDeatisById?.address?.city}
                          headerName="District"
                        />
                      </div>
                      <div className="flex gap-4 space_18  relative">
                        <TotalsCard
                          totalVal={marketDeatisById?.address?.addressLine}
                          headerName="Street & Village"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div
                      className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                    >
                      <span className="fs-14">mOS Users</span>
                    </div>
                    <div className="card_space_18">
                      <div className="flex gap-4   relative">
                        <TotalsCard
                          totalVal={marketDeatisById?.users?.clickCount}
                          headerName="CLICK"
                          className="flex-1"
                        />
                        <TotalsCard
                          totalVal={marketDeatisById?.users?.tradeCount}
                          headerName="TRADE"
                        />
                        <TotalsCard
                          totalVal={marketDeatisById?.users?.cashCount}
                          headerName="CASH"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="relative">
                    <div
                      className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                    >
                      <span className="fs-14">
                        Top Crops ({marketDeatisById?.crops?.length})
                      </span>
                    </div>
                    <div className="card_space_18">
                      {marketDeatisById?.crops.length > 0 ? (
                        <div className="grid grid-cols-3  gap-4 relative">
                          {marketDeatisById?.crops.slice(0, 6).map((i) => (
                            <div className="flex  gap-2 items-center flex-1">
                              <div>
                                <img
                                  src={i.cropUrl}
                                  alt="ui"
                                  className="br-100"
                                  style={{ width: "40px", height: "40px" }}
                                />
                              </div>
                              <div className="fs-14">{i.cropName} </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="flex items-center justify-center w-full h-full">
                          <img
                            src={NodataAvailable}
                            alt="No data available"
                            className="w-[110px]"
                          />
                        </div>
                      )}
                    </div>
                    {marketDeatisById?.crops.length > 0 && (
                      <div className=" bottom-0 border-t w-100">
                        <div className="p-3">
                          <Button
                            variant="outlined-primary"
                            text="See All"
                            onClick={() => {
                              setShowSeeAllCrops(true);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </CardHeaderBG>
                <CardHeaderBG
                  titile={"3rd Party Market Softwares"}
                  titileClassName="bg-oceangreen"
                  icon=""
                  className="space_18"
                >
                  <div className="card_space_18">
                    {" "}
                    {marketDeatisById?.softwares.length > 0 ? (
                      <div className="grid grid-cols-2  gap-4 relative">
                        {marketDeatisById?.softwares.map((i) => (
                          <div className="flex  gap-2 items-center flex-1">
                            <div>
                              <AccountBalanceOutlined
                                style={{
                                  fontSize: 24,
                                  color: "color-sub-text",
                                }}
                              />
                            </div>
                            <div className="fs-14">{i.name} </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex items-center justify-center w-full h-full">
                        <img
                          src={NodataAvailable}
                          alt="No data available"
                          className="w-[110px]"
                        />
                      </div>
                    )}
                  </div>
                  <div className="">
                    <div
                      className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                    >
                      <span className="fs-14">Banking Partners</span>
                    </div>
                    <div className="card_space_18">
                      {marketDeatisById?.bankPartners.length > 0 ? (
                        <div className="grid grid-cols-2  gap-4 relative">
                          {marketDeatisById?.bankPartners.map((i) => (
                            <div className="flex  gap-2 items-center flex-1">
                              <div>
                                <AccountBalanceOutlined
                                  style={{
                                    fontSize: 24,
                                    color: "color-sub-text",
                                  }}
                                />
                              </div>
                              <div className="fs-14">{i.name} </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="flex items-center justify-center w-full h-full">
                          <img
                            src={NodataAvailable}
                            alt="No data available"
                            className="w-[110px]"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </CardHeaderBG>
              </div>
              <div className="w-50 flex flex-col">
                <CardHeaderBG
                  titile={"Market Hours"}
                  titileClassName="bg-oceangreen"
                  icon=""
                  className=""
                >
                  <MarketHoursList
                    marketHoursList={marketDeatisById?.marketOps}
                  />
                  <div>
                    <div
                      className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                    >
                      <span className="fs-14">Holidays / Events</span>
                    </div>
                    <MarketMonthsData data={marketDeatisById?.holidays} />
                  </div>
                </CardHeaderBG>

                {(activeMarketTab === "ALL" ||
                  activeMarketTab === "REJECTED") &&
                  marketDeatisById?.remarks !== null && (
                    <CardHeaderBG
                      titile={` ${activeMarketTab === "ALL" ? "Approved" : "Rejection"} Remarks`}
                      titileClassName="bg-oceangreen"
                      icon=""
                      className="space_18"
                    >
                      <div className="bg-white p-4 h-40 fs-14">
                        {marketDeatisById?.remarks}
                      </div>
                    </CardHeaderBG>
                  )}
              </div>
            </div>
          </div>
        ) : (
          <>
            {isLoading ? (
              <div className="border-t border-gray-300 bg-white">
                <div className="flex items-center justify-center py-4">
                  <img src={Loading} alt="loading" className="w-16 h-16" />
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center w-full h-full py-10 mt-10">
                <img src={NodataAvailable} alt="No data available" />
              </div>
            )}
          </>
        )}
        <>
          <div className="bg-white flex absolute  bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">
            <Button
              className="w-26"
              variant="oceanGreen"
              data-shape="round"
              onClick={() => {
                dispatch(setOpenMarketDetailsPanel(false));
                dispatch(setEditMarketDetailsStatus(false));
              }}
            >
              Cancel
            </Button>
            {marketDeatisById != null &&
              hasAdminManagerEditAccess &&
              activeMarketTab === "ALL" && (
                <div className="flex gap-4">
                  <Button
                    variant="lightRed"
                    onClick={() => {
                      setDeletMarketModalStatus(true);
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    // className="w-[100px]"
                    variant="contained"
                    onClick={() => {
                      onEditClick();
                      dispatch(setEditMarketDetailsStatus(true));
                      dispatch(setMarketImages([]));
                      dispatch(
                        udpateAddMarketData({
                          addMarketData: {
                            ...marketDeatisById,
                            status:
                              marketDeatisById?.status === 1
                                ? "ACTIVE"
                                : "INACTIVE",
                          },
                        }),
                      );
                    }}
                  >
                    Edit Market
                  </Button>
                </div>
              )}
            {activeMarketTab === "PENDING" && (
              <div className="flex gap-4">
                <Button
                  variant="lightRed"
                  onClick={() => {
                    setRejectMarketModalStatus(true);
                    dispatch(resetApprRejectFields());
                  }}
                >
                  Reject
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setApproveMarketModalStatus(true);
                    dispatch(resetApprRejectFields());
                  }}
                >
                  Approve
                </Button>
              </div>
            )}
          </div>
        </>
      </div>

      {showSeeAllCrops && (
        <PanelSlider
          direction="right_to_left"
          open={showSeeAllCrops}
          onClose={() => {
            setShowSeeAllCrops(false);
          }}
          style={{ width: "40vw" }}
        >
          <div
            // ref={panelRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            className="panel-content"
          >
            <div className="border-b card_space_18 flex items-center justify-between">
              <div>
                <h2 className="fs-14 font-bold">Total Crops</h2>
              </div>
              <div>
                <img
                  src={cancelIcon}
                  alt=""
                  className="cursor-pointer"
                  onClick={() => {
                    setShowSeeAllCrops(false);
                  }}
                />
              </div>
            </div>

            <>
              <div className="w-100 card_space_18 layout_bg">
                {" "}
                <div className=" relative">
                  <div>
                    {marketDeatisById && marketDeatisById?.crops.length > 0 ? (
                      <>
                        <div className=" border br-10 bg-white">
                          <div
                            className={`card_bg_head bg-oceangreen flex gap-2 items-center `}
                            style={{ borderRadius: "10px 10px 0px 0px" }}
                          >
                            <span className="fs-14">Total Crops</span>
                          </div>
                          <div
                            className="overflow-auto"
                            style={{ height: "calc(100vh - 8rem)" }}
                          >
                            <div className="">
                              <div className="grid grid-cols-3 relative">
                                {marketDeatisById?.crops.map((i) => {
                                  return (
                                    <div className="flex items-center gap-2 flex-1 p-3 border-r border-b">
                                      <div>
                                        <img
                                          src={i.cropUrl}
                                          alt="ui"
                                          className="br-100"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                          }}
                                        />
                                      </div>
                                      <div className="fs-14">{i.cropName} </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="flex items-center justify-center h-full">
                        <img src={NodataAvailable} alt="No data available" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          </div>
        </PanelSlider>
      )}
      {deletMarketModalStatus && (
        <>
          <Modal
            open={deletMarketModalStatus}
            onClose={() => {
              onCloseDeleteModal();
            }}
            width={"40vw"}
          >
            <>
              <ModalHeader title={"Delete Market"} content={<></>} />
              <div className="py-10 px-8">
                <DeleteMarket
                  allMarketsData={allMarketsData}
                  selectDeleteMarkets={selectDeleteMarkets || null}
                  setSelectDelMarkets={setSelectDelMarkets}
                  marketName={marketDeatisById?.marketName || ""}
                  selectedMarketId={marketDeatisById?.marketId || ""}
                />
              </div>
              <ModalFooter>
                <Button
                  className="w-26"
                  variant="gray"
                  data-shape="round"
                  onClick={() => {
                    onCloseDeleteModal();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="w-26"
                  variant="danger"
                  data-shape="round"
                  onClick={() => {
                    onClickDeleteMarket();
                  }}
                >
                  {selectDeleteMarkets != null
                    ? "Delete"
                    : "Delete Permanently"}
                </Button>
              </ModalFooter>
            </>
          </Modal>
        </>
      )}
      {/* reject flow */}
      {rejectMarketModalStatus && (
        <>
          <Modal
            open={rejectMarketModalStatus}
            onClose={() => {
              setRejectMarketModalStatus(false);
            }}
            width={"40vw"}
          >
            <>
              <ModalHeader title={"Reject Request"} content={<></>} />
              <div className="py-10 px-8">
                <RejectMarket />
              </div>
              <ModalFooter>
                <Button
                  className="w-26"
                  variant="gray"
                  data-shape="round"
                  onClick={() => {
                    setRejectMarketModalStatus(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="w-26"
                  variant="danger"
                  data-shape="round"
                  onClick={() => {
                    handleRejectMarket();
                  }}
                >
                  Reject
                </Button>
              </ModalFooter>
            </>
          </Modal>
        </>
      )}
      {/* approve flow */}
      {approveMarketModalStatus && (
        <>
          <Modal
            open={approveMarketModalStatus}
            onClose={() => {
              setApproveMarketModalStatus(false);
            }}
            width={"40vw"}
          >
            <>
              <ModalHeader title={"Approve Request"} content={<></>} />
              <div className="py-10 px-8">
                <ApproveMarket
                  approveMarketModalStatus={approveMarketModalStatus}
                />
              </div>
              <ModalFooter>
                <Button
                  className="w-26"
                  variant="gray"
                  data-shape="round"
                  onClick={() => {
                    setApproveMarketModalStatus(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="w-26"
                  variant="contained"
                  data-shape="round"
                  onClick={() => {
                    handleApproveMarket();
                  }}
                >
                  Approve
                </Button>
              </ModalFooter>
            </>
          </Modal>
        </>
      )}
    </>
  );
};
export default MarketDetailsById;
